import { gql } from '__generated__';

export default gql(`
  mutation InviteParticipant($input: InviteParticipantInput!) {
    inviteParticipant(input: $input) {
      ...RegistrationFields
    }
  }
`);
